// extracted by mini-css-extract-plugin
module.exports = {"CoverSectionEU":"CoverSectionEU2_CoverSectionEU__bs1Fp"};